'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAction = exports.getAnalyticsType = exports.getActionSubjectId = exports.getObjectIds = exports.getObjectTypes = exports.getContainerIds = exports.getContainerTypes = exports.getTags = exports.getAttributes = exports.getSources = exports.getActionSubject = exports.getComponents = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _uniq = require('lodash/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extractFromEventContext = function extractFromEventContext(propertyNames, event) {
    return event.context.reduce(function (acc, contextItem) {
        propertyNames.forEach(function (propertyName) {
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
};

var extractFromEventPayload = function extractFromEventPayload(propertyName, event) {
    return event.payload[propertyName];
};

var extractFromPayloadOrContext = function extractFromPayloadOrContext(propertyName, event) {
    var payloadProp = extractFromEventPayload(propertyName, event);
    var contextProps = extractFromEventContext([propertyName], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};

var extractPayloadAttributes = function extractPayloadAttributes(event) {
    var _event$payload = event.payload,
        tags = _event$payload.tags,
        actionSubjectId = _event$payload.actionSubjectId,
        containerType = _event$payload.containerType,
        containerId = _event$payload.containerId,
        objectType = _event$payload.objectType,
        objectId = _event$payload.objectId,
        analyticsType = _event$payload.analyticsType,
        name = _event$payload.name,
        action = _event$payload.action,
        actionSubject = _event$payload.actionSubject,
        attributes = (0, _objectWithoutProperties3.default)(_event$payload, ['tags', 'actionSubjectId', 'containerType', 'containerId', 'objectType', 'objectId', 'analyticsType', 'name', 'action', 'actionSubject']);


    return attributes;
};

var getComponents = exports.getComponents = function getComponents(event
/*
Temporary using 'component' and 'componentName' fields.
This should be replaced with 'componentName' only once we bump all the ak components.
*/
) {
    return extractFromEventContext(['component', 'componentName'], event);
};

var getActionSubject = exports.getActionSubject = function getActionSubject(event) {
    return extractFromEventPayload('actionSubject', event);
};

var getSources = exports.getSources = function getSources(event) {
    return extractFromEventContext(['source'], event);
};

var getAttributes = exports.getAttributes = function getAttributes(event) {
    return (0, _merge2.default)(extractFromEventContext(['attributes'], event).reduce(function (result, extraAttributes) {
        return (0, _merge2.default)(result, extraAttributes);
    }, {}), extractPayloadAttributes(event));
};

var getTags = exports.getTags = function getTags(event) {
    var tags = (0, _uniq2.default)(extractFromEventContext(['tags'], event).reduce(function (result, extraTags) {
        return result.concat(extraTags);
    }, []).concat(extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};

var getContainerTypes = exports.getContainerTypes = function getContainerTypes(event) {
    return extractFromPayloadOrContext('containerType', event);
};

var getContainerIds = exports.getContainerIds = function getContainerIds(event) {
    return extractFromPayloadOrContext('containerId', event);
};

var getObjectTypes = exports.getObjectTypes = function getObjectTypes(event) {
    return extractFromPayloadOrContext('objectType', event);
};

var getObjectIds = exports.getObjectIds = function getObjectIds(event) {
    return extractFromPayloadOrContext('objectId', event);
};

// singluar extractors

var getActionSubjectId = exports.getActionSubjectId = function getActionSubjectId(event) {
    return extractFromEventPayload('actionSubjectId', event);
};

var getAnalyticsType = exports.getAnalyticsType = function getAnalyticsType(event) {
    return extractFromEventPayload('analyticsType', event);
};

var getAction = exports.getAction = function getAction(event) {
    return extractFromEventPayload('action', event);
};